export default class SsoSettings {
    constructor (json) {
        this.orgId = 0;
        this.isSsoEnabled = false;
        this.ssoIdentityProviderUrl = undefined;
        this.hideSkipLink = false;
        this.authenticationType = null;
        if (json)
            mapJsonToSettings(json, this);
    }
}

const mapJsonToSettings = (json, organization) => {
    organization.orgId = json.OrganizationId;
    organization.isSsoEnabled = json.AuthenticationType == "Sso";
    organization.ssoIdentityProviderUrl = json.SsoIdentityProviderUrl;
    organization.hideSkipLink = json.HideSkipLink;
    organization.authenticationType = json.AuthenticationType;
};

